import React, { FC } from 'react';
import { SVGProps } from '@utils';
import { SvgWrapper } from './SvgWrapper';

interface OpenCloseIconProps extends SVGProps {
  isClose?: boolean;
}

export const OpenCloseIcon: FC<OpenCloseIconProps> = ({ onClick, divClassName, isClose=false }) => (
  <SvgWrapper
    divClassName={divClassName}
    onClick={onClick}
  >
    <svg 
      style={isClose ? { transform: 'rotateX(180deg)' } : {}}
      width="18" 
      height="10" 
      viewBox="0 0 18 10" 
      fill="none" 
      xmlns="http://www.w3.org/2000/svg"
    >
      <path 
        id="Vector" 
        d="M9 -7.28926e-05L18 9.87598L-5.68427e-07 9.87597L9 -7.28926e-05Z" 
        fill="#7E818C"
      />
    </svg>
  </SvgWrapper>
);
